/**
 * Countdown for the urgency bar.
 *
 * Two ways to set the deadline:
 *   fixed     — a date and time the shop chooses; the same moment for everyone
 *   evergreen — a window that starts when this visitor first sees the bar, kept
 *               in localStorage so it survives a reload rather than restarting
 *               on every page view
 *
 * The markup already carries the final digits server-side where it can, so a
 * visitor without JS still sees a sensible bar rather than empty boxes.
 */
(function () {
  var SELECTOR = '[data-urgency-bar]';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function readStore(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStore(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* private mode, quota — the timer just becomes per-page-view */
    }
  }

  function deadlineFor(bar) {
    var mode = bar.getAttribute('data-mode');

    if (mode === 'evergreen') {
      var hours = parseFloat(bar.getAttribute('data-window')) || 24;
      var key = 'urgency-bar:' + (bar.getAttribute('data-key') || 'default');
      var stored = parseInt(readStore(key), 10);
      var now = Date.now();

      if (!stored || isNaN(stored) || stored <= now) {
        stored = now + hours * 3600 * 1000;
        writeStore(key, String(stored));
      }
      return stored;
    }

    var iso = bar.getAttribute('data-deadline');
    var parsed = iso ? Date.parse(iso) : NaN;
    return isNaN(parsed) ? null : parsed;
  }

  function setup(bar) {
    if (bar.urgencyBarReady) return;
    bar.urgencyBarReady = true;

    var deadline = deadlineFor(bar);
    if (!deadline) return;

    var fields = {
      days: bar.querySelector('[data-unit="days"]'),
      hours: bar.querySelector('[data-unit="hours"]'),
      minutes: bar.querySelector('[data-unit="minutes"]'),
      seconds: bar.querySelector('[data-unit="seconds"]')
    };
    var showDays = !!fields.days;
    var expired = bar.getAttribute('data-expired') || 'hide';
    var timer = null;

    function finish() {
      if (timer) clearInterval(timer);

      if (expired === 'restart') {
        var key = 'urgency-bar:' + (bar.getAttribute('data-key') || 'default');
        writeStore(key, '');
        deadline = deadlineFor(bar);
        timer = setInterval(tick, 1000);
        return;
      }

      if (expired === 'hide') {
        bar.hidden = true;
        return;
      }

      bar.setAttribute('data-state', 'expired');
    }

    function tick() {
      var remaining = deadline - Date.now();

      if (remaining <= 0) {
        Object.keys(fields).forEach(function (unit) {
          if (fields[unit]) fields[unit].textContent = '00';
        });
        finish();
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);

      if (!showDays) hours += days * 24;

      if (fields.days) fields.days.textContent = pad(days);
      if (fields.hours) fields.hours.textContent = pad(hours);
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      if (fields.seconds) fields.seconds.textContent = pad(totalSeconds % 60);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
